import { useCallback } from 'react';
import ConfirmDialog from '../ConfirmDialog';
import Api from '../../api';

interface PhotoAnnounceModalProps {
    open: boolean;
    photoUrl?: string;
    linkUrl?: string;
    role: 'hygienist' | 'dentist';
    /** T2-6085: office only — the currently-selected location, so id-list images
     *  are marked seen for that location only. */
    locationId?: number | null;
    onDismiss: () => void;
}

export default function PhotoAnnounceModal({ 
    open,
    photoUrl,
    linkUrl,
    role,
    locationId,
    onDismiss,
}: PhotoAnnounceModalProps) {
    const handleDismiss = useCallback(async () => {
        try {
            if (role === 'hygienist') {
                await Api.seenPhoto();
            } else {
                await Api.seenPhotoDentist(locationId);
            }
        } catch {}
        onDismiss();
        try { (window as any)?.TempStars?.User?.refresh?.(); } catch {}
    }, [role, locationId, onDismiss]);

    const handleLinkClick = useCallback(() => {
        if (!linkUrl) return;
        if ((window as any).Cordova) {
            (window as any).cordova.InAppBrowser.open(linkUrl, '_system', 'location=yes');
        } else {
            window.open(linkUrl, '_blank', 'noopener,noreferrer');
        }
    }, [linkUrl]);

    return (
        <ConfirmDialog
            open={open}
            onClose={handleDismiss}
            content={(
                <div style={{ position: 'relative', margin: '-24px', padding: 0 }}>
                    <button
                        type="button"
                        onClick={handleDismiss}
                        style={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            border: 'none',
                            background: 'rgba(0, 0, 0, 0.6)',
                            color: '#fff',
                            fontSize: 20,
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                            lineHeight: 1,
                            padding: 0,
                        }}
                        aria-label="Close announcement"
                    >
                        ×
                    </button>
                    {photoUrl ? (
                        linkUrl && linkUrl.trim() !== '' ? (
                            <button
                                type="button"
                                onClick={handleLinkClick}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer',
                                    display: 'block',
                                    width: '100%',
                                }}
                                aria-label="View announcement details - click to learn more"
                            >
                                <img
                                    src={photoUrl}
                                    alt="announcement - click to learn more"
                                    style={{ width: '100%', display: 'block', borderRadius: 8, transition: 'opacity 0.2s ease' }}
                                    onMouseOver={(e) => { e.currentTarget.style.opacity = '0.85'; }}
                                    onMouseOut={(e) => { e.currentTarget.style.opacity = '1'; }}
                                />
                            </button>
                        ) : (
                            <img src={photoUrl} alt="announcement" style={{ width: '100%', display: 'block', borderRadius: 8 }} />
                        )
                    ) : null}
                </div>
            )}
            actions={[]}
        />
    );
}
